import React from 'react';

function TrashIcon({ w, h, style }) {
  return (
    <svg style={style} width={w} height={h} viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.89443677,3.32237288 L5.2347236,3.32237288 L0.674097784,3.32237288 L1.63498435,12.3050847 L5.2347236,12.3050847 L5.89443677,12.3050847 L9.49417601,12.3050847 L10.4550626,3.32237288 L5.89443677,3.32237288 Z"
        id="Fill-1"
      />
      <path
        d="M3.85790222,0.0136586441 L3.85790222,1.03908237 L1.43415909e-05,1.03908237 L1.43415909e-05,2.72077729 L5.23469492,2.72077729 L5.89440808,2.72077729 L11.1290887,2.72077729 L11.1290887,1.03908237 L7.27120078,1.03908237 L7.27120078,0.0136586441 L3.85790222,0.0136586441 Z"
        id="Fill-2"
      />
    </svg>
  );
}

TrashIcon.defaultProps = {
  w: 12,
  h: 13,
};

module.exports = TrashIcon;
